module.exports = __webpack_public_path__ + "static/media/logo.ec0482fc.svg";